













































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import shave from 'shave';

import bButton from 'bootstrap-vue/es/components/button/button';
import bCol from 'bootstrap-vue/es/components/layout/col';
import bContainer from 'bootstrap-vue/es/components/layout/container';
import bImg from 'bootstrap-vue/es/components/image/img';
import bLink from 'bootstrap-vue/es/components/link/link';
import bRow from 'bootstrap-vue/es/components/layout/row';

import AvailabilityBlock from '@/components/AvailabilityBlock.vue';
import BottomPanel from '@/components/BottomPanel.vue';
import PriceBlock from '@/components/PriceBlock.vue';
import PrimaryButton from '@/components/PrimaryButton.vue';
import QuantityInput from '@/components/QuantityInput.vue';

import CartView from './CartView';
import EmptyCartView from './EmptyCartView.vue';

@Component({
  components: {
    AvailabilityBlock,
    BottomPanel,
    EmptyCartView,
    PriceBlock,
    PrimaryButton,
    QuantityInput,

    bButton,
    bCol,
    bContainer,
    bImg,
    bLink,
    bRow,
  },
})
export default class MobileCartView extends mixins(CartView) {
  public mounted() {
    this.clampTitle();
  }

  public updated() {
    this.clampTitle();
  }

  private clampTitle() {
    shave('.sc-item-title', 48, {
      spaces: false,
    });
  }
}

